<template>
  <v-menu
    offset-overflow
    v-bind:top="top"
    v-bind:left="left"
    v-bind:content-class="contentClass"
    v-bind:absolute="absolute"
    v-bind:attach="attach"
    v-bind:close-on-content-click="closeOnContentClick"
    v-bind:offset-x="offsetX"
    v-bind:offset-y="offsetY"
    v-bind:position-x="positionX"
    v-bind:position-y="positionY"
    v-bind:value="isShown"
    v-on:input="onInput"
  >
    <template v-slot:activator="{ on }">
      <slot
        name="trigger"
        v-bind:listener-object="on" />
    </template>
    <slot />
  </v-menu>
</template>
<script>
import { popoverMixin } from '@/mixins/builtInPopoverMixin';

/**
 * @description Компонент диалогового меню.
 * @type {Vue}
 */
export default {
  mixins: [
    popoverMixin,
  ],
  name: 'PopoverMenu',
  computed: {
    /**
     * @description Определить кастомный набор классов.
     */
    contentClass() {
      const overflowClass = this.defineOverflowClass();
      const overflowVisible = this.overflowVisible ? 'popover-overflow-visible' : '';
      return [
        'popover-menu-vuetify',
        this.customClass,
        overflowClass,
        overflowVisible,
      ].join(' ').trim();
    },
  },
  methods: {
    /**
     * @description Определить css-класс для установки свойства overflow.
     * @returns {string}
     */
    defineOverflowClass() {
      return this.overflowAuto ? 'overflow-auto' : '';
    },
  },
  props: {
    /**
     * @description Закрывать по нажатию на контент.
     */
    closeOnContentClick: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Content-класс для поповера.
     * @type {string}
     */
    customClass: { default: () => '', type: String },
    /**
     * @description Абсолютное позиционирование.
     * @type {boolean}
     */
    absolute: { default: () => false, type: Boolean },
    /**
     * @description Скролл при переполнении контейнера.
     * @type {boolean}
     */
    overflowAuto: { default: () => false, type: Boolean },
    /**
     * @description Показывать содержимое за границами контейнера.
     * @type {boolean}
     */
    overflowVisible: { default: () => false, type: Boolean },
    /**
     * @description К какому элементу прикреплять.
     * @type {any}
     */
    attach: { default: () => false, type: [Object, Boolean] },
    /**
     * @description Выравнивание компонента по левой стороне.
     * @type {boolean}
     */
    left: { default: () => false, type: Boolean },
    /**
     * @description Выравнивание компонента по верхней стороне.
     * @type {boolean}
     */
    top: { default: true, type: Boolean },
    /**
     * @description Смещение по оси y.
     * @type {boolean}
     */
    offsetX: { default: () => false, type: Boolean },
    /**
     * @description Смещение по оси x.
     * @type {boolean}
     */
    offsetY: { default: () => true, type: Boolean },
    /**
     * @description Позиция по х.
     * @type {number}
     */
    positionX: { default: () => undefined, type: Number },
    /**
     * @description Позиция по y.
     * @type {number}
     */
    positionY: { default: () => undefined, type: Number },
    /**
     * @description Показывать.
     * @type {boolean}
     */
    value: {
      default: () => false,
      type: Boolean,
    },
  },
  watch: {
    value(updatedValue) {
      this.isShown = updatedValue;
    },
  },
};
</script>
<style scoped lang="scss">
.popover-menu-vuetify {
  background-color: var(--primary-background-color);
  &.overflow-auto {
    overflow: auto;
  }
  &.popover-overflow-visible {
    overflow: visible;
    contain: none;
  }
}
</style>
